import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const CallToActionWrapper = styled(Box)(({ theme }) => ({
  backgroundImage: 'url(/images/shivay/italian/calacatta.jpg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  position: 'relative',
  padding: theme.spacing(3, 0),
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
  },
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  textAlign: 'center',
  color: 'white',
}));

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
  padding: theme.spacing(1, 4),
  borderRadius: theme.shape.borderRadius,
  textTransform: 'none',
  fontSize: '1.1rem',
}));

const CallToAction = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <CallToActionWrapper>
      <Container>
        <ContentWrapper>
          <Typography variant="h3" component="h2" gutterBottom>
            Transform Your Space with Premium Materials
          </Typography>
          <Typography variant="h6" paragraph sx={{ mb: 4 }}>
            Discover our exclusive collection of Italian marble, Spanish marble, premium granite, and modern epoxy finishes.
            Elevate your interior design with our carefully curated selection.
          </Typography>
          {/* <Box>
            <StyledButton
              variant="contained"
              color="primary"
              onClick={() => scrollToSection('products-section')}
            >
              Explore Collections
            </StyledButton>
            <StyledButton
              variant="outlined"
              color="inherit"
              onClick={() => scrollToSection('shivay-info-section')}
            >
              Contact Us
            </StyledButton>
          </Box> */}
        </ContentWrapper>
      </Container>
    </CallToActionWrapper>
  );
};

export default CallToAction; 